import React from "react";
import ParaplanningInputField from "./ParaplanningInputField";
import { ReactComponent as AddIcon } from "../../../assets/icons/add.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import "../../../css/Praplanning/MultipleClients.css";
import "../../../css/Praplanning/AddCaseModal.css";

const MultipleClientsSection = ({
  clientFirstName,
  clientLastName,
  clients = [],
  onFieldChange,
  onAddClient,
  onUpdateClient,
  onRemoveClient,
}) => {
  return (
    <div className="ParaplanningField ParaplanningField--Full">
      <span className="ParaplanningField__Label FP_Body">
        Client Name
        <span className="ParaplanningField__Required">*</span>
      </span>

      <div className="ParaplanningClients__Row">
        <div className="ParaplanningClients__FirstName">
          <ParaplanningInputField
            value={clientFirstName}
            placeholder="Client First Name"
            onChange={(value) => onFieldChange("clientFirstName", value)}
          />
        </div>

        <div className="ParaplanningClients__LastName">
          <ParaplanningInputField
            value={clientLastName}
            placeholder="Client Last Name"
            onChange={(value) => onFieldChange("clientLastName", value)}
          />
        </div>

        <button
          type="button"
          className="ParaplanningAdditionalCharges__IconButton"
          onClick={onAddClient}
          aria-label="Add client"
        >
          <AddIcon />
        </button>
      </div>

      {!!clients.length && (
        <div className="ParaplanningClients__List">
          {clients.map((client) => (
            <div key={client.id} className="ParaplanningClients__Row">
              <div className="ParaplanningClients__FirstName">
                <ParaplanningInputField
                  value={client.firstName}
                  placeholder="Client First Name"
                  onChange={(value) =>
                    onUpdateClient(client.id, "firstName", value)
                  }
                />
              </div>

              <div className="ParaplanningClients__LastName">
                <ParaplanningInputField
                  value={client.lastName}
                  placeholder="Client Last Name"
                  onChange={(value) =>
                    onUpdateClient(client.id, "lastName", value)
                  }
                />
              </div>

              <button
                type="button"
                className="ParaplanningAdditionalCharges__IconButton ParaplanningAdditionalCharges__IconButton--Delete"
                onClick={() => onRemoveClient(client.id)}
                aria-label="Remove client"
              >
                <DeleteIcon />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultipleClientsSection;
